import { httpUtil } from './httpUtil';

const querystring = require('querystring');

let urlPaygate = document._portalConfig.urlSSLCommerz;
let apiKeyPaygate = document._portalConfig.apiKeySSLCommerz;

let urlPlugins = document._portalConfig.urlPluginsApi;
let apiKeyPlugins = document._portalConfig.apiKeyPluginsApi;

export const aynaottservices = {
    initiateOrderPayment,
    initiateTopup,
    getContactSubscriptions,
    makeOrder,
}

async function initiateOrderPayment({
    estimate_id,
    total_amount,
    currency,
    payment_result_url,
    payment_redirect_url,
    account_fund_amount,
    wallet_funds_amount,
    use_wallet_funds,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let body = {
            contact_id: id,
            estimate_id,
            total_amount,
            currency,
            payment_result_url,
            payment_redirect_url,
            use_wallet_funds,
        }
        if(account_fund_amount) body.account_fund_amount = account_fund_amount;
        if(wallet_funds_amount) body.wallet_funds_amount = wallet_funds_amount;
        const response = await post({
            resourcePath: '/plugins/initiate_order_payment',
            body: body,
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function initiateTopup({
    account_id,
    total_amount,
    currency,
    payment_result_url,
    payment_redirect_url,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/plugins/initiate_payment',
            body: {
                contact_id: id,
                account_id: account_id,
                total_amount,
                currency,
                payment_result_url,
                payment_redirect_url,
            },
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getContactSubscriptions({
    include_only_terminated,
    include_terms,
    include_billing_info,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/plugins/contact/' + id + "/subscriptions",
            queryParams: {
                include_only_terminated: include_only_terminated,
                include_terms: include_terms,
                include_billing_info: include_billing_info,
            }
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function makeOrder({
    account_id,
    total_amount,
    use_wallet_funds,
    account_funds_amount,
    wallet_funds_amount,
    estimate_id,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let body = {
            contact_id: id,
            account_id: account_id,
            total_amount,
            use_wallet_funds,
            estimate_id,
        }
        if(account_funds_amount) body.account_funds_amount = account_funds_amount;
        if(wallet_funds_amount) {
            body.wallet_funds_amount = wallet_funds_amount;
            body.wallet_fund_amount = wallet_funds_amount;
        }
        const response = await post({
            resourcePath: '/plugins/make_order',
            body: body,
            isPaygate: false,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

function createOption(isPaygate) {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'api_key': isPaygate ? apiKeyPaygate : apiKeyPlugins,
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath, isPaygate) {
   if(isPaygate) return urlPaygate + resourcePath;
   else return urlPlugins + resourcePath;
}

async function get({
    resourcePath,
    queryParams,
    isPaygate
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'GET';
        let uri = getURI(resourcePath, isPaygate);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    isPaygate,
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'POST';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);
        console.log("POST uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
